import { subscribe } from '@wh/message-bus';
import { events } from '@wh/quick-deposit';

// tslint:disable-next-line:variable-name
let _quickDepositIsOpen = false;

subscribe(events.MESSAGE_SUB_QD_OPEN, () => (_quickDepositIsOpen = true));
subscribe(events.MESSAGE_PUB_QD_CLOSE, () => (_quickDepositIsOpen = false));

export default () => ({ isOpen: _quickDepositIsOpen });
